import { goto } from '$app/navigation'

export function setQueryParams({
  browser,
  params,
  existingParams,
  noScroll,
}: {
  browser: boolean
  params: Record<string, string>
  existingParams: URLSearchParams
  noScroll?: boolean
}) {
  if (browser) {
    const query = new URLSearchParams(existingParams)

    for (const [param, value] of Object.entries(params)) {
      if (value === '') {
        query.delete(param)
      } else {
        query.set(param, value)
      }
    }

    if (query.toString() !== existingParams.toString()) {
      return goto(`?${query.toString()}`, { noScroll })
    }
  }
}
